import { render, staticRenderFns } from "./AnticipoAdmin.vue?vue&type=template&id=637638b2&"
import script from "./AnticipoAdmin.vue?vue&type=script&lang=js&"
export * from "./AnticipoAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AnticipoAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports